export default __webpack_public_path__ + "static/12-adfa31e8ea542207da0dd9239dafc73c.png";